import {Component, ViewChild} from '@angular/core';
import {Content, Events, IonicPage, NavController, NavParams} from 'ionic-angular';
import {ChatClientProvider} from "../../providers/chat-client/chat-client";
import {UserStateProvider} from "../../providers/user-state/user-state";
import * as moment from "moment";
import {ContentTranslationProvider} from "../../providers/content-translation/content-translation";

/**
 * Generated class for the AppChatDetailsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

export class ChatMessage {
  remoteMessage: boolean;
  date: Date;
  viewedAt: string;
  text: string;
  firstMessageInDate: string = '';
  authorName: string = '';
  rootMessage: boolean = false;
  systemMessage: boolean = false;
}

@IonicPage()
@Component({
  selector: 'page-app-chat-details',
  templateUrl: 'app-chat-details.html',
})
export class AppChatDetailsPage {
  @ViewChild(Content) public content: Content;

  messages: Array<ChatMessage>;
  lastId: number;
  nextPageAvailable: boolean = true;
  loaded: number = 0;
  textMessage: string;
  eventHandler: any;
  supportAvailableHandler: any;
  keyboardWillShowHandler: any;
  keyboardDidHideHandler: any;
  room: string = 'public';
  user: any;

  roomTitle: string = this.contentTranslation.translateContent('Experten-Chat');
  isPartnerMode: boolean = false;

  infiniteScroll: any = null;

  supportAvailable:boolean = false;

  constructor(public navCtrl: NavController, public navParams: NavParams, public chatClient: ChatClientProvider, public state: UserStateProvider, public events: Events, public contentTranslation: ContentTranslationProvider) {
    this.messages = new Array<ChatMessage>();
    this.loaded = 0;
    moment.updateLocale('de',function() {

    });

    this.user = this.state.user;

    var me = this;

    this.room = (this.navParams.data as string);

    if(this.room.length > 46) {
      this.roomTitle = 'Mein '+this.user.partnerData.profession;
      this.isPartnerMode = true;
    }

    this.eventHandler = msgData => {
      if(msgData.conversation_id == this.room) {
        me.addMessage(msgData, me);
        this.events.publish('chat:opened', {id: msgData.conversation_id});
        this.chatClient.markRead(this.room)
      }
    };
    this.events.subscribe('message:received', this.eventHandler);

    this.keyboardWillShowHandler = (e) => {
      console.log('did show handler', e);
      setTimeout(() => {
        this.content.resize();
        console.log('did show handler timeout 1');
      }, 100);
      setTimeout(() => {
        console.log('did show handler timeout 2');
        this.content.scrollToBottom().then();
      }, 150);

      console.log(window.innerHeight, window.outerHeight, )
    }
    this.events.subscribe('app:keyboard-did-show-handler', this.keyboardWillShowHandler);

    this.keyboardDidHideHandler = () => {
      this.content.resize();
      setTimeout(() => {
        this.content.resize();
        this.content.scrollToBottom().then();
      }, 10);
    }
    this.events.subscribe('app:keyboard-did-hide-handler', this.keyboardDidHideHandler);


    if(!this.chatClient.checkConnection()) {
      this.chatClient.connect();
    }

    this.supportAvailableHandler = (e) => {
      this.supportAvailable = e.status;
    }

    this.events.subscribe('chat:supportAvailable', this.supportAvailableHandler);


  }

  scanMessageForFirstInDate() {
    var lastDate = null;
    if(this.messages && this.messages.length) {
      lastDate = this.messages[0].date.toDateString();
    }
    this.messages.map(msg => {
      if(!msg.authorName) {
        return ;
      }
      if(msg.date.toDateString() != lastDate) {
        lastDate = msg.date.toDateString();
        msg.firstMessageInDate = moment(msg.date).format('dddd, D MMM');
      } else {
        msg.firstMessageInDate = null
      }
    })
  }

  loadMessages():Promise<any> {
    var me = this;
    if(!me.nextPageAvailable) {
      return ;
    }

    return new Promise((resolve, reject) => {
      me.chatClient.loadMessageHistory(me.room, me.lastId).then((msgs:any) => {
        me.nextPageAvailable = msgs.nextPage;
        console.log(msgs);
        for(var k in msgs.data) {
          var msgData = msgs.data[k];
          var chatMsg = new ChatMessage();
          chatMsg.remoteMessage = (me.state.user.id != msgData.author_id);
          chatMsg.viewedAt = (msgData.viewed_at)?(moment(msgData.viewed_at).format('DD.MM.YY')):null;
          chatMsg.text = msgData.text;
          chatMsg.date = new Date(msgData.created_at);
          chatMsg.authorName = msgData.authorName;
          chatMsg.rootMessage = msgData.root_message;
          me.messages.unshift(chatMsg)

          me.lastId = msgData.id;
        }

        me.scanMessageForFirstInDate();
        resolve();
      }).catch(reject);
    })
  }

  addMessage(msgData: any, me: AppChatDetailsPage) {
    if(msgData.conversation_id != me.room) {
      return ;
    }
    var chatMsg = new ChatMessage();
    chatMsg.remoteMessage = (me.state.user.id != msgData.author_id);
    chatMsg.text = msgData.text;
    chatMsg.date = new Date(msgData.created_at);
    chatMsg.viewedAt = (msgData.viewed_at)?(moment(msgData.viewed_at).format('LL')):null;
    chatMsg.authorName = msgData.authorName;
    chatMsg.rootMessage = msgData.root_message;
    me.messages.push(chatMsg)

    me.scanMessageForFirstInDate();
    console.log('addMessage', msgData);

    setTimeout(function() {
      if(me.content) {
        me.content.resize();
        me.content.scrollToBottom();
      }
    }, 100);
  }

  scrollInProgress: boolean = false;
  ionViewDidLoad() {
    var me = this;
    this.loadMessages().then((res) => {
      if (this.scrollInProgress) {
        me.loaded++;
      } else {
        this.scrollInProgress = true;
        me.content.scrollToBottom().then(() => {
          this.scrollInProgress = false;
          me.loaded++;
        })
      }
      ;
    });

    this.supportAvailable = this.chatClient.supportAvailable

    this.events.publish('chat:opened', {id: this.room});
  }

  ionViewDidEnter() {
    var me = this;
    if(this.scrollInProgress) {
      me.loaded++;
    } else {
      this.scrollInProgress = true;
      this.content.scrollToBottom().then(() => {
        this.scrollInProgress = false;
        me.loaded++;
      });
    }
  }

  hideKeyboard() {
    this.isLeaving = true;
    setTimeout(() => {
      this.navCtrl.pop();
    }, 100);
  }

  isLeaving: boolean = false;
  ionViewWillLeave() {
    this.isLeaving = true;
  }

  ionViewDidLeave() {
    this.events.unsubscribe('message:received', this.eventHandler);
    this.events.unsubscribe('app:keyboard-did-show-handler', this.keyboardWillShowHandler);
    this.events.unsubscribe('app:keyboard-did-hide-handler', this.keyboardDidHideHandler);
    this.events.unsubscribe('chat:supportAvailable', this.supportAvailableHandler);
  }


  scrollToLastMessage() {
    this.content.resize();
  }

  doInfinite(infiniteScroll) {
    if(this.loaded!=2) {
      setTimeout(function() {
        infiniteScroll.complete();
      }, 100);
      return false;
    }

    var promise = this.loadMessages();
    if(promise) {
      promise.then(res => {
        infiniteScroll.complete();
      });
    } else {
      infiniteScroll.enable(false);
    }

    this.infiniteScroll = infiniteScroll;

    // infiniteScroll.complete();
  }

  sendMessage(textMessage: string) {
    if (!textMessage) {
      return ;
    }
    console.log('send message', textMessage);
    this.textMessage = '';

    this.chatClient.sendMessage(this.room, textMessage);
    this.events.publish('chat:message-sent')
  }
}



// WEBPACK FOOTER //
// ./src/pages/app-chat-details/app-chat-details.ts